/**************************************************
 * Nombre:       Tarjeta_Ahorro
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, LinearProgress, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {Box} from "@mui/system";
import TituloTexto from "./Componentes/TituloTexto";
import {obtenerTotalAhorrado} from "../../CodNegocio/Bolsillo/obtenerTotalAhorrado";
import {formatoMoneda} from "../../Modulo_Wompi/Utilidades/formatoMoneda";
import {useEffect, useState} from "react";
import {obtenerPorcentaje} from "../../CodNegocio/obtenerPorcentaje";
import {obtenerFechaProximosRendimientos} from "../../CodNegocio/Bolsillo/obtenerFechaProximosRendimientos";
import {obtenerTiempoTranscurrido} from "../../CodNegocio/Bolsillo/obtenerTiempoTranscurrido";
import {obtenerTotalRendimientos} from "../../CodNegocio/Bolsillo/obtenerTotalRendimientos";
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import TituloCuentaRegresiva from "./Componentes/TituloCuentaRegresiva";
import {obtenerMesesTranscurridos} from "../../CodNegocio/Bolsillo/obtenerMesesTranscurridos";
import {EditSquare} from "@mui/icons-material";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Ahorro from "../Dialogos/Dialogo_Ahorro";
import Dialogo_Ahorro_Editar from "../Dialogos/Dialogo_Ahorro_Editar";

dayjs.locale('es');


const Tarjeta_Ahorro = ({alto = 212, item, recargar}) => {
    const [totalAhorrado, setTotalAhorrado] = useState(0);
    const [porcentaje, setPorcentaje] = useState(0);
    const [rendimientos, setRendimientos] = useState(0);
    const [meses, setMeses] = useState(0)
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Ahorro_Editar, titulo: 'Editando Ahorro', realizado: recargar})

    const obtenerDatos = async (it) => {
        let total = await obtenerTotalAhorrado({idBolsillo: it.id})
        let porcentaje = obtenerPorcentaje({valor: it.valor, total: total});
        let redis = await obtenerTotalRendimientos({idBolsillo: it.id, idUsuario: it.idUsuario});
        let mesTras = obtenerMesesTranscurridos({bolsillo: it})

        setTotalAhorrado(total)
        setPorcentaje(porcentaje)
        setRendimientos(redis)
        setMeses(mesTras)
    }

    useEffect(() => {

        obtenerDatos(item).then()

    }, [item]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: theme.palette.info.main,
                p: 2,
                borderRadius: 4,
                color: '#fff',
                minHeight: alto
            }}
        >

            <Grid container size={10} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 24, fontWeight: 600}}>{`Ahorro: ${item.nombre}`}</Typography>
            </Grid>

            <Dialogo/>

            <Grid container size={1} sx={{justifyContent: 'flex-end'}}>
                <Typography sx={{fontSize: 20, fontWeight: 800}}>{`${porcentaje}%`}</Typography>
            </Grid>

            <Grid container size={1} sx={{justifyContent: 'flex-start', mt: -0.6}}>
                <IconButton onClick={() => abrir(item)}>
                    <EditSquare sx={{fill: theme.palette.primary.main}}/>
                </IconButton>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Box sx={{width: '100%'}}>
                    <LinearProgress variant="determinate" value={porcentaje}/>
                </Box>
            </Grid>

            <Grid container size={6} sx={{justifyContent: 'flex-start', mt: 3}}>
                <TituloTexto titulo={'Ahorro + Rendimientos'} texto={formatoMoneda(totalAhorrado)}/>
            </Grid>

            <Grid container size={6} sx={{justifyContent: 'flex-start', mt: 3}}>
                <TituloCuentaRegresiva titulo={'Nuevos Rendimientos'}
                                       fecha={obtenerFechaProximosRendimientos({item: item})} dir={'flex-end'}
                                       textoS={18}
                                       mt={0.6}/>
            </Grid>

            <Grid container size={6} sx={{justifyContent: 'flex-start', mt: 2}}>
                <TituloTexto titulo={'Tiempo'}
                             texto={`${obtenerTiempoTranscurrido({fechaInicio: item.fecha})} de ${item.numMeses} Meses`}
                             textoS={20}/>
            </Grid>

            <Grid container size={6} sx={{justifyContent: 'flex-start', mt: 2}}>
                <TituloTexto titulo={'Rendimientos Totales'} texto={formatoMoneda(rendimientos)} textoS={20}/>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Ahorro    